/**
 * This enum provide periodicity types constants.
 */
export enum PeriodicityTypes {
    MONTHLY = '0b3c7d3b-57a0-49fa-98d5-3cb07a372377',
    FORTNIGHTLY = '0be9520e-88a9-49f1-b87d-c846b53d5d1c',
}

/**
 * This enum provide period index constants.
 */
export enum PeriodIndex {
    MONTHLY = 0,
    FORTNIGHTLY = 1,
}
